import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export interface ActiveFilter {
  id: string;
  label: string;
  /** e.g. "SUBJECT English" or "Active" */
  displayText: string;
}

export interface ActiveFilterPillsProps {
  filters: ActiveFilter[];
  onRemove: (id: string) => void;
  onClearAll: () => void;
  className?: string;
}

/**
 * Reusable active filter pills + Clear All button.
 * Use for teachers list, students list, or any filtered list.
 */
export function ActiveFilterPills({
  filters,
  onRemove,
  onClearAll,
  className,
}: ActiveFilterPillsProps) {
  const { t } = useTranslation("common");
  if (filters.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {filters.map((f) => (
        <span
          key={f.id}
          className="inline-flex items-center gap-1.5 rounded-md bg-[#F0F0F0] px-3 py-1.5 text-sm text-[#333333]"
        >
          {f.displayText}
          <button
            type="button"
            onClick={() => onRemove(f.id)}
            className="rounded p-0.5 text-[#555555] hover:bg-[#E0E0E0] hover:text-[#333333]"
            aria-label={`${t("actions.clearAll")} ${f.displayText}`}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="rounded-md px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-50 hover:text-red-700"
      >
        {t("actions.clearAll")}
      </button>
    </div>
  );
}
